import { useEffect, useState } from 'react';
import { Button } from '@/ui/Button';
import { Dialog } from '@/ui/Dialog';

/**
 * piezas.tsx — lo que comparten las dieciséis secciones.
 */

/** El texto de búsqueda, pero solo cuando quien escribe se detiene. */
export function useBusquedaDemorada(texto: string, ms = 400): string {
  const [valor, setValor] = useState(texto.trim());
  useEffect(() => {
    const t = window.setTimeout(() => setValor(texto.trim()), ms);
    return () => window.clearTimeout(t);
  }, [texto, ms]);
  return valor;
}

/**
 * La contraseña temporal que devuelve el servidor.
 *
 * Sale una sola vez y lo único que se hace con ella es pasársela a alguien, así
 * que tiene su botón de copiar. El vanilla la pintaba como texto suelto en un
 * modal y había que seleccionarla a mano.
 *
 * No se guarda en ninguna parte ni se vuelve a pedir: si se pierde, se
 * restablece otra vez.
 */
export function ClaveGenerada({
  titulo, clave, nota, onCerrar,
}: {
  titulo: string;
  clave: string;
  nota?: string;
  onCerrar: () => void;
}) {
  const [copiada, setCopiada] = useState(false);

  return (
    <Dialog
      abierto
      onCambio={(v) => { if (!v) onCerrar(); }}
      titulo={titulo}
      descripcion={nota}
      ancho="max-w-md"
      pie={<Button onClick={onCerrar}>Entendido</Button>}
    >
      <div className="flex items-center gap-2 pb-2">
        <p className="flex-1 rounded-sm border border-dashed border-line-strong bg-sunken p-3 text-center font-mono text-5 font-bold text-brand-ink">
          {clave}
        </p>
        <Button
          variant="secondary"
          aria-label="Copiar la contraseña"
          onClick={() => {
            void navigator.clipboard.writeText(clave);
            setCopiada(true);
            window.setTimeout(() => setCopiada(false), 2000);
          }}
        >
          <i className={`bi ${copiada ? 'bi-check2' : 'bi-clipboard'}`} aria-hidden="true" />
          {copiada ? 'Copiada' : 'Copiar'}
        </Button>
      </div>
      <p className="pb-2 text-1 text-muted">
        No se vuelve a mostrar. Si se pierde, se restablece otra vez.
      </p>
    </Dialog>
  );
}

/** Las quince claves de módulo del RBAC, con su nombre en la interfaz. */
export const NOMBRES_DE_MODULO: Record<string, string> = {
  feed: 'Novedades / Comunicaciones',
  cursos: 'Formación',
  eventos: 'Eventos',
  kudos: 'Reconocimientos',
  recursos: 'Biblioteca',
  encuestas: 'Encuestas',
  celebraciones: 'Celebraciones',
  directorio: 'Directorio',
  notificaciones: 'Notificaciones',
  comunidades: 'Comunidades',
  documentos: 'Documentos / Solicitudes',
  reportes: 'Informes',
  analitica: 'Analítica',
  recursos_privados: 'Recursos y Datos',
  administracion: 'Administración',
};
